import { Select } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { BasicButton, BasicTextArea } from '../../assets/common';

const options = [
  {
    value: 'Development Plan',
    label: 'Development Plan',
  },
  {
    value: 'Double Hatting',
    label: 'Double Hatting',
  },
  {
    value: 'Next Mobility',
    label: 'Next Mobility',
  },
  {
    value: 'Next 2 Mobility',
    label: 'Next 2 Mobility',
  },
  {
    value: 'End State',
    label: 'End State',
  },
  {
    value: 'Others',
    label: 'Others',
  },
  {
    value: 'Notes',
    label: 'Notes',
  },
];

const ProposalRemarks = (props) => {
  const { isOnlyViewAgenda, handleAddRemark } = props;
  const [optionSelected, setOptionSelected] = useState(null);
  const [remark, setRemark] = useState('');

  function handleClickAdd() {
    handleAddRemark({ category: optionSelected, remark });
    setOptionSelected(null);
    setRemark('');
  }

  return (
    <div style={{ margin: '10px 0' }}>
      {!isOnlyViewAgenda && (
        <CustomSelect
          disabled={isOnlyViewAgenda}
          placeholder="Select"
          style={{
            width: 120,
          }}
          allowClear
          options={options}
          value={optionSelected}
          onChange={(value) => setOptionSelected(value)}
        />
      )}
      {optionSelected && (
        <div style={{ margin: '10px 0', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '10px' }}>
          <BasicTextArea rows={4} value={remark} onChange={(e) => setRemark(e.target.value)} resize="none" border="#D9D9D9" />
          <BasicButton width="100px" mode="teal-bold" onClick={() => handleClickAdd()}>
            Add
          </BasicButton>
        </div>
      )}
    </div>
  );
};

const CustomSelect = styled(Select)`
  width: 100% !important;
  border-radius: 4px;

  &.ant-select-disabled {
    cursor: no-drop;
    .ant-select-selector {
      color: #15191e !important;
      background: var(--color-background-strong, #f0f5fa) !important;
    }
  }
`;

export default ProposalRemarks;
